import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import Icontrash from "../../../../layout/others/icon_delete.svg";
import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

export default function Availability() {
  const {
    searchObject,
    setSearchObject,
    onChange,
    t
  } = useAdvanceSearchContext();

  const [avaibilities, setAvaibilities] = useState([]);
  const [noticeTimeOptions, setNoticeTimeOptions] = useState([]);
  function onchangeAvailability({ target }) {
    if (target.checked)
      setSearchObject({
        ...searchObject,
        AvailabilityStatusId: Number(target.value)
      });
  }

  function clearAvailability() {
    let _searchObject = { ...searchObject };
    _searchObject.AvailabilityStatusId = undefined;
    _searchObject.noticeId = undefined;

    setSearchObject(_searchObject);
  }

  useEffect(() => {
    CommonService.getAvailabilities().then((data) => setAvaibilities(data));
    CommonService.getNoticeOptions().then((data) => setNoticeTimeOptions(data));
  }, []);

  return (
    <>
      <fieldset>
        <legend>{t("Availability")}</legend>
        <button
          style={{ position: "relative", float: "right" }}
          onClick={clearAvailability}
          className="app-button btn-second btn-md"
        >
          <img src={Icontrash} alt="ico-ppl" height="12px" width="auto" />{" "}
        </button>
        <div>
          {avaibilities.map((avail) => (
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="availabilityStatusId"
                value={avail.id}
                id={t(avail.description)}
                checked={searchObject.AvailabilityStatusId === avail.id}
                onChange={onchangeAvailability}
              />
              <label className="form-check-label" for={avail.description}>
                {t(avail.description)}
              </label>
            </div>
          ))}
        </div>
        <div>
          <select
            className="form-select"
            onChange={onChange}
            name="noticeId"
            id="noticeId"
            value={searchObject.noticeId || ""}
          >
            <option key={0} value="" selected>
              {t("Avaibility...")}
            </option>
            {noticeTimeOptions.map((notice) => (
              <option value={notice.id} key={notice.id}>
                {t(notice.description)}
              </option>
            ))}
          </select>
        </div>
      </fieldset>
    </>
  );
}
